export default function Reducer(prevState, action){
    switch (action.type) {
        case "IS_LOADING":
            return {
                ...prevState,
                is_loading: true,
                is_show_date_filter: false,
            };
        case "IS_LOADED": 
            return {
                ...prevState,
                is_loading: false,
                total_ftms: action.total_ftms,
                total_pages: action.total_pages,
                ftms_ratings: action.ftms_ratings
            }; 
        case "UPDATE_CURRENT_PAGE":
            return {
                ...prevState,
                current_page: action.current_page
            } 
        case "SET_SERACH_TEXT":
            return {
                ...prevState,
                current_page: 1,
                serach_text: action.serach_text,
            }; 
        case "SET_SORT_CONFIG":
            return {
                ...prevState,
                sort_key: action.sort_key,
                sort_direction: action.sort_direction,
            }; 
        case "IS_SHOW_DATE_FILTER":
            return {
                ...prevState,
                is_show_date_filter: action.is_show_date_filter,
            };
        case "SET_ERROR": 
            return {
                ...prevState,
                error: action.error
            };
        case "SET_DATE_RANGE": 
            return {
                ...prevState,
                start_date: action.start_date,
                end_date: action.end_date
            };
        default:
            return prevState;
    }
}